<template>
  <v-app-bar
    app
    color="white"
    clipped-right
    clipped-left
    flat
    class="elevation-1"
  >
    <!-- Opción de menú de páginas -->
    <v-btn
      v-if="editing"
      icon
      @click="toggleLeftMenu"
    >
      <v-icon>mdi-menu</v-icon>
    </v-btn>

    <v-img
      :style="'cursor:pointer'"
      @click="goToPage('/')"
      contain
      max-height="30"
      max-width="90"
      src="@/assets/complete_logo.png"
    />

    <!-- Botones de edición y guardado -->
    <template v-if="isDeveloper()">
      <v-btn
        @click="updateEditing"
        class="ml-5"
      >
        <v-icon v-if="editing">mdi-play-circle-outline</v-icon>
        <v-icon v-else>mdi-stop-circle-outline</v-icon>
      </v-btn>
      <v-btn @click="save()"> Guardar </v-btn>
    </template>

    <v-spacer></v-spacer>

    <template v-if="!isLaboratory()">
      <v-btn
        v-if="has_history"
        class="mt-1 mr-2 elevation-1"
        @click="goToPage('history')"
      >
        <v-icon>mdi-history</v-icon>
      </v-btn>
      <v-btn
        v-if="connection"
        class="mt-1 mr-2 elevation-1"
        @click="resetAlarms"
      >
        <v-icon>mdi-sync-alert</v-icon>
      </v-btn>
      <v-btn
        class="mt-1 mr-2 elevation-1"
        @click="goToPage('alarms')"
      >
        <v-icon>mdi-alert</v-icon>
      </v-btn>
    </template>
    
    <!-- Botón para hacer copia de seguridad -->
    <v-btn
      v-if="isDeveloper()"
      class="mt-1 mr-2 elevation-1"
      @click="openBackupDialog"
    >
      <v-icon>mdi-content-save</v-icon>
      Copia de seguridad
    </v-btn>

    <v-tooltip
      bottom
      v-if="!isProduction()"
    >
      <template v-slot:activator="{ on }">
        <v-btn
          class="mt-1 elevation-1"
          v-on="on"
          @click="logoutFromApp"
        >
          <v-icon>mdi-logout</v-icon>
        </v-btn>
      </template>
      <span>Cerrar Sesión</span>
    </v-tooltip>

    <!-- Diálogo para pedir el nombre del archivo -->
    <v-dialog v-model="dialog" persistent max-width="500px">
      <v-card>
        <v-card-title>
          <span class="headline">Guardar copia de seguridad</span>
        </v-card-title>
        <v-card-text>
          <v-text-field v-model="backupFileName" label="Nombre del archivo" />
        </v-card-text>
        <v-card-actions>
          <v-btn color="primary" text @click="makeBackup">Guardar</v-btn>
          <v-btn text @click="closeDialog">Cancelar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </v-app-bar>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";

export default {
  data() {
    return {
      dialog: false, // Controla el diálogo
      backupFileName: "", // Almacena el nombre del archivo
    };
  },
  computed: {
    ...mapState(["editing", "pages", "selectedPage"]),

    connection() {
      return this.actualPage()?.global_item_list.find((gi) => gi.settings.component_type == "koiote-snap7-connection");
    },

    has_history() {
      return (
        this.$route.path == "/history" ||
        this.actualPage()
          ?.global_item_list.find((gi) => gi.settings.component_type.includes("connection"))
          ?.customized?.vartable?.some((v) => v?.seconds > 0)
      );
    },

    writeTopic() {
      return this.connection?.customized.topic_write;
    },
  },

  methods: {
    ...mapGetters(["actualPage", "isDeveloper", "isLaboratory", "isProduction"]),
    ...mapActions(["updateEditing", "changeShowLeftMenu", "logout", "setSelectedPageToHome", "postData", "loadPages"]),
    ...mapActions("nodered", ["doPublish"]),

    toggleLeftMenu() {
      this.changeShowLeftMenu();
    },

    async save() {
      for (const page of this.pages) {
        const pageToStore = JSON.parse(JSON.stringify(page));
        pageToStore?.global_item_list
          ?.filter((gi) => gi.settings.component_type.includes("connection"))
          .forEach((c) => {
            (c.customized?.vartable || []).forEach((v) => {
              v.value = "";
            });
          });
        await this.postData({ path: "pages", body: pageToStore });
      }
      this.loadPages();
    },

    resetAlarms() {
      const formattedResetAddress = this.connection.customized.vartable.find(
        (v) => v.formatted_address == this.connection.customized.reset_address
      )?.address;

      this.doPublish({
        topic: this.writeTopic,
        message: {
          address: formattedResetAddress,
          value: true,
        },
      });
    },

    goToPage(goToPageName) {
      if (goToPageName == "/") this.setSelectedPageToHome();
      if ((goToPageName == "/" && this.$route.path != goToPageName) || !this.$route.path.includes(goToPageName)) {
        if (goToPageName == "history") goToPageName = goToPageName + "/" + this.selectedPage;
        this.$router.push({ path: goToPageName == "/" ? goToPageName : "/" + goToPageName });
      }
    },

    logoutFromApp() {
      this.logout();
      location.reload(true);
      this.$router.push(`login`).catch(() => {}); //Si hay cambios sin guardar se cancela el cambio de ruta
    },

    // Abre el diálogo para pedir el nombre del archivo
    openBackupDialog() {
      this.dialog = true;
    },
    
    // Cierra el diálogo sin hacer nada
    closeDialog() {
      this.dialog = false;
    },

    // Llama al endpoint para hacer la copia de seguridad
    async makeBackup() {
      try {
        const payload = {name: this.backupFileName}
        const response = await this.postData({ path: "backups", body:  payload});
        console.log('respuesta del backup',response);
        if (response.ok) {
          alert('Copia de seguridad realizada con éxito.');
        } else {
          alert('Error al realizar la copia de seguridad.');
        }
      } catch (error) {
        alert('Error en la conexión: ' + error.message);
      }

      this.closeDialog();
    },
  },
};
</script>
